/* eslint-disable react-hooks/exhaustive-deps */
import useToggleStyle from "hooks/useToggleStyle";
import { useWhiteLabelBranding } from "hooks/useWhiteLabelBranding";
import { useAppContext } from "providers/AppProvider";
import { useSettingsPanelContext } from "providers/SettingsPanelProvider";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ErrorBoundary from "components/common/ErrorBoundary";

const App = () => {
  const { isStylesheetLoaded } = useToggleStyle();
  const { pathname } = useLocation();
  
  // Initialize white-label branding if applicable
  const { isWhiteLabel, tenant, isLoading: brandingLoading } = useWhiteLabelBranding();

  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    settingsPanelConfig: { showSettingPanelButton },
    setSettingsPanelConfig,
  } = useSettingsPanelContext();

  const {
    config: { theme, isRTL },
  } = useAppContext();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    setSettingsPanelConfig({
      openSettingPanel: false,
    });
  }, [isRTL]);

  return (
    <>
      {!isStylesheetLoaded ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: theme === "dark" ? "#000" : "#fff",
          }}
        />
      ) : (
        <>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
          {/* {showSettingPanelButton && (
            <>
              <SettingsToggle />
              <SettingsPanel />
            </>
          )} */}
        </>
      )}
    </>
  );
};

export default App;
